export function cleanCsvHeader(label) {
  return String(label)
    .replace(/^\uFEFF/, '')
    .trim()
    .replace(/^"(.*)"$/, '$1')
    .trim()
}

export function repairMojibake(value) {
  let text = String(value)
  if (!/[\u00c3\u00c2\u00e2]/.test(text)) return text

  try {
    let encoded = text
      .split('')
      .map(char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0'))
      .join('')
    return decodeURIComponent(encoded)
  } catch (e) {
    return text
  }
}

export function normalizeCsvHeader(label) {
  return cleanCsvHeader(repairMojibake(cleanCsvHeader(label))).normalize('NFC')
}

function normalizeHeaderForComparison(label) {
  return normalizeCsvHeader(label)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

function headerPattern(label) {
  let escaped = normalizeHeaderForComparison(label)
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/(?:\\\?|\uFFFD)+/g, '.+')

  return new RegExp('^' + escaped + '$')
}

export function areCsvHeadersEquivalent(a, b) {
  let normalizedA = normalizeHeaderForComparison(a)
  let normalizedB = normalizeHeaderForComparison(b)

  if (normalizedA === normalizedB) return true
  return headerPattern(a).test(normalizedB) || headerPattern(b).test(normalizedA)
}

function resolveMicrodataCellKey(row, column, usedKeys) {
  let label = column.label
  let candidates = [
    label,
    cleanCsvHeader(label),
    normalizeCsvHeader(label),
    String(label).replace(/^\uFEFF/, ''),
    String(label).trim(),
  ]

  let resolvedKey = candidates.find(candidate =>
    !usedKeys.has(candidate) && Object.prototype.hasOwnProperty.call(row, candidate)
  )

  if (!resolvedKey) {
    let normalizedLabel = normalizeCsvHeader(label)
    resolvedKey = Object.keys(row).find(
      key => !usedKeys.has(key) && normalizeCsvHeader(key) === normalizedLabel
    )
  }

  if (!resolvedKey) {
    resolvedKey = Object.keys(row).find(
      key => !usedKeys.has(key) && areCsvHeadersEquivalent(key, label)
    )
  }

  return resolvedKey
}

export function createMicrodataRowResolver(row, columns) {
  let usedKeys = new Set()
  let resolvedKeys = columns.map(column => {
    let key = resolveMicrodataCellKey(row, column, usedKeys)
    if (key) usedKeys.add(key)
    return key
  })

  let unresolvedRowKeys = Object.keys(row).filter(key => !usedKeys.has(key))
  return column => {
    let columnIndex = columns.indexOf(column)
    let resolvedKey = resolvedKeys[columnIndex]

    if (!resolvedKey) {
      let unresolvedColumnIndex = resolvedKeys.slice(0, columnIndex + 1).filter(key => !key).length - 1
      resolvedKey = unresolvedRowKeys[unresolvedColumnIndex]
    }

    return resolvedKey ? row[resolvedKey] : undefined
  }
}

export function getMicrodataCellValue(row, column, columns) {
  if (columns) return createMicrodataRowResolver(row, columns)(column)

  let resolvedKey = resolveMicrodataCellKey(row, column, new Set())
  return resolvedKey ? row[resolvedKey] : undefined
}
